import axios from "axios";
import {authHeader} from "../helpers/auth-header";

const getNetworkResetDeviceList = () => {
    return axios.get(`/api/NetworkDeviceResetators`, { headers: authHeader()})
        .then((res) => { return res.data });
}

const getNetworkResetDeviceById = (networkResetId) => {
    return axios.get(`/api/NetworkDeviceResetators/${networkResetId}`, { headers: authHeader() })
        .then((res) =>  { return res.data } )
}

const createNetworkResetDevice = (networkResetModel) => {
    delete networkResetModel.id;
    delete networkResetModel.resetatorId;
    delete networkResetModel.resetator.id;

    return axios.post(`/api/NetworkDeviceResetators`, networkResetModel, { headers: authHeader() } )
        .then((res) => { return res.data })
}

const editNetworkResetDevice = (networkResetModel) => {
    return axios.patch(`/api/NetworkDeviceResetators/${networkResetModel.id}`, networkResetModel, { headers: authHeader() } )
        .then((res) => { return res.data })
}

const removeNetworkResetDevice = (networkResetDeviceId) => {
    return axios.delete(`/api/NetworkDeviceResetators/${networkResetDeviceId}`, { headers: authHeader() })
        .then((res) => { return res.data })
}

const manualReset = (networkResetDeviceId) => {
    return axios.patch(`/api/NetworkDeviceResetators/ManualReset/${networkResetDeviceId}`, {}, { headers: authHeader() })
        .then((res) => { return res.data })
}

const clearState = (networkResetDeviceId) => {
    return axios.patch(`/api/NetworkDeviceResetators/ClearState/${networkResetDeviceId}`, {}, { headers: authHeader() })
        .then((res) => { return res.data })
}

export const networkResetDeviceService = {
    getNetworkResetDeviceList,
    getNetworkResetDeviceById,
    createNetworkResetDevice,
    editNetworkResetDevice,
    removeNetworkResetDevice,
    manualReset,
    clearState
}
